<template>
  <piece-card title="车场动态">
    <div class="crowd-list flex-box">
      <InfoCard
        v-for="(item, index) in infoList"
        :key="index"
        :title="item.title"
        :value="item.value"
        class="info-item flex-grow"
      />
    </div>
    <ScreenTable :data="data" :columns="columns" class="car-table" />
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";
import InfoCard from "../../components/info-card.vue";
import ScreenTable from "../../components/screen-table.vue";

export default {
  name: "Car",
  components: {
    PieceCard,
    InfoCard,
    ScreenTable,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {
      columns: [
        { title: "下发时间", prop: "create_time", align: "center" },
        { title: "车牌号码", prop: "num", align: "center" },
        { title: "联系人", prop: "user_name", align: "center" },
      ],
    };
  },
  computed: {
    infoList() {
      const { car = {} } = this.info || {};
      const count = car?.count || []; // [报备车辆数,报备进入数,入场车辆数,出场车辆数]
      const total = count[0] || 0;
      const enter = count[1] || 0;
      return [
        { title: "报备车辆数", value: total },
        { title: "报备到达率", value: `${total === 0 ? 0 : Math.round((Math.min(total, enter) / total) * 100)}%` },
        { title: "入场车辆数", value: count[2] || 0 },
        { title: "出场车辆数", value: count[3] || 0 },
      ];
    },
    data() {
      return this.info?.jrbc || [];
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.info-item {
  &:not(:last-of-type) {
    margin-right: 5px;
  }
}
.car-table {
  height: 150px;
  margin-top: 4px;
}
</style>
